module.exports = __webpack_public_path__ + "img/index03.15cbaa14.png";